import React from 'react';
import PropTypes from 'prop-types';
import WalletSpinner from '../components/wallet-spinner/index';

const additionalInformation = (missingTrackingParams) => {
  if (missingTrackingParams.length > 0) {
    return (
      <div
        style={{
          backgroundColor: '#FFCDD2',
          borderColor: '#B71C1C',
          borderStyle: 'solid',
          borderWidth: 1,
          padding: 8,
          fontSize: 13,
          color: '#B71C1C',
          marginTop: 6,
          marginBottom: 6,
        }}
      >
        <b>The following tracking query params are missing:</b>
        <p>{missingTrackingParams.join(', ')}</p>
      </div>
    );
  }
  return null;
};

const Default = (props) => (
  <div className="redirect-holder">
    {additionalInformation(props.missingTrackingParams)}

    <WalletSpinner />
    {props.suppressRedirect && (
      <p>
        Supressed redirect to{' '}
        <a
          data-automation-id="suppressed-redirect-link"
          href={props.product.destinationUrl}
        >
          {props.product.destinationUrl}
        </a>
        <br />
      </p>
    )}
  </div>
);

Default.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  product: PropTypes.object.isRequired,
  suppressRedirect: PropTypes.bool,
  missingTrackingParams: PropTypes.arrayOf(PropTypes.string),
};

Default.defaultProps = {
  missingTrackingParams: [],
};

Default.displayName = 'Default';

export default Default;
